import {
  isDocRef,
  TypeGuard,
  type DocumentReference,
} from '@principle-theorem/shared';
import { type IBrand } from '../brand';
import { type IPractice } from '../practice/practice';

export enum QueryScopeConfigId {
  Brand = 'brand',
  Practice = 'practice',
}

export interface IBrandQueryRequest {
  brandRef: DocumentReference<IBrand>;
}

export const isBrandQueryRequest = TypeGuard.interface<IBrandQueryRequest>({
  brandRef: isDocRef,
});

export interface IPracticeQueryRequest {
  practiceRefs: DocumentReference<IPractice>[];
}

export const isPracticeQueryRequest =
  TypeGuard.interface<IPracticeQueryRequest>({
    practiceRefs: TypeGuard.arrayOf(isDocRef),
  });

export interface IQueryScopeRequests {
  [QueryScopeConfigId.Brand]?: IBrandQueryRequest;
  [QueryScopeConfigId.Practice]?: IPracticeQueryRequest;
}

export const isQueryScopeRequests = TypeGuard.interface<IQueryScopeRequests>({
  brand: TypeGuard.undefinedOr(isBrandQueryRequest),
  practice: TypeGuard.undefinedOr(isPracticeQueryRequest),
});
